import { createApp } from 'vue'
import Tip from './Tip.vue'
import './assets/global.css'

createApp(Tip).mount('#tip')
